import script from "./FormulaContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormulaContent.vue?vue&type=script&lang=ts&setup=true"

import "./FormulaContent.vue?vue&type=style&index=0&id=567417d3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-567417d3"]])

export default __exports__